import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { HodAccountsService } from "../../admin/data-access/services/hod-accounts.service";
import { universityProfilesActions, userProfilesActions } from "./profile-management.actions";
import { exhaustMap, map, of } from "rxjs";
import { UsersAndUniversityDepartments } from "../../admin/data-access/models/user-information.model";
import { catchError } from "rxjs/operators";
import { Faculty } from "../../admin/data-access/models/faculties-model";

@Injectable()
export class ProfileManagementEffects {
  constructor(
    private actions$: Actions,
    private accountService: HodAccountsService
  ) {}

  loadUserProfiles = createEffect(() =>
    this.actions$.pipe(
      ofType(userProfilesActions.getUserProfiles),
      exhaustMap(() =>
        this.accountService.getAccounts().pipe(
          map((data) =>
            userProfilesActions.getUserProfilesSuccess({ userProfiles: data.results as UsersAndUniversityDepartments })),
          catchError((error) => of(userProfilesActions.getUserProfilesFailure({ error: error.message })))
        )
      )
    )
  )

  loadUniversityFaculties = createEffect(() =>
    this.actions$.pipe(
      ofType(universityProfilesActions.getFaculties),
      exhaustMap(() =>
        this.accountService.getFaculties().pipe(
          map((data) =>
            universityProfilesActions.getFacultiesSuccess({ faculties: data.results as Faculty[] })),
          catchError((error) => of(universityProfilesActions.getFacultiesFailure({ error: error.message })))
        )
      )
    )
  )
}
